import el from "@cypherpotato/el";

export function Row(...children) {
    return el("div.flex-row",
        ...children
    )
}

export function Column(...children) {
    return el("div.flex-column",
        ...children
    )
}

export function Main(...children) {
    return el("main",
        ...children
    )
}

export function Section(...children) {
    return el("section",
        ...children
    )
}

export function Padding(size, ...children) {
    return el("div", {
        style: {
            padding: size + "rem"
        }
    }, ...children);
}

export function SmallContainer(...children) {
    return el("div",
        {
            style: {
                maxWidth: "400px"
            }
        },
        ...children
    )
}

export function MediumContainer(...children) {
    return el("div",
        {
            style: {
                maxWidth: "600px"
            }
        },
        ...children
    )
}

export function CenteredContainer(...children) {
    return el("div",
        {
            style: {
                maxWidth: "1600px",
                marginLeft: "auto",
                marginRight: "auto"
            }
        },
        ...children
    )
}

export function Content(...children) {
    return el("div.content",
        ...children
    )
}